import React, { useEffect, useState } from 'react'
import NewsBlock from "../newsBlock/newsBlock";


const MainPage: React.FC = () => {


	return (

			<main>
				<NewsBlock/>
			</main>
	)
}

export default MainPage
